document.addEventListener("DOMContentLoaded", function() {

    moveAffirmElementBelowPrice();    
    
});

function moveAffirmElementBelowPrice() {
    // Couldn't figure out how to move it in the html, so this hack exists
    if (document.body.classList.contains('template-product')) {
        var affirmPaymentsEl = document.querySelector(".shopify-payment-terms")
        var newParent = document.querySelector(".product-block--price")

        newParent.appendChild(affirmPaymentsEl);
    }
}